import React, { useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Icon } from "@/components";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./styles.scss";
import DashboardLayout from "@/layouts/dashboard-layout";
import truncateString from "@/utils/truncateString";
import { useAuth } from "@/contexts/auth-context";
import { formatGameTimeStamp, formatTimeStamp } from "@/utils/function";
import { completionFn } from "@/redux/slice/activity/completion";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { useCompletionContext } from "@/contexts/PointsContext";
import { Activity } from "@/types/activity";

export const Complete = () => {
  const { lesson_id } = useParams();
  const dispatch = useAppDispatch();
  const { data, error, loading } = useAppSelector((state) => state.completion);
  const { data: activity } = useAppSelector((state) => state.activities);

  const {
    data: activityLessons,
    error: activityErrors,
    loading: activityLoading,
  } = useAppSelector((state) => state.activityLesson);

  const completedItem =
    activityLessons &&
    activityLessons.find((a: Activity) => a.id === lesson_id);
  activityLessons && activityLessons.find((a: Activity) => a.id === lesson_id);

  const { points, setPoints } = useCompletionContext();

  useEffect(() => {
    if (!points || points?.length === 0) {
      setPoints(completedItem?.points);
    }
  }, [activityLessons]);

  const navigate = useNavigate();
  const { trialCount, gameTimeStamp, activityValue, token, details } =
    useAuth();

  const numberOfQuestion = activityLoading
    ? 1
    : activity && activity.length > 0
    ? activity[0].activityType === "ChatActivity"
      ? activity[0].series?.length
      : activity.length
    : 1;

  const accuracy = activity
    ? activity[0].activityType === "ChatActivity"
      ? numberOfQuestion / (trialCount + numberOfQuestion)
      : numberOfQuestion / trialCount
    : 0;

  const fetch = useCallback(() => {
    if (details) {
      dispatch(
        completionFn({
          token: token!,
          activityValue,
          time: formatTimeStamp((gameTimeStamp?.end - gameTimeStamp?.start) / 1000),
          id: details?.id,
          accuracy: accuracy,
        })
      );
    }
  }, [
    accuracy,
    activityValue,
    details,
    dispatch,
    gameTimeStamp?.end,
    gameTimeStamp?.start,
    token,
  ]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <DashboardLayout>
      {loading ? (
        <p>Loading</p>
      ) : (
        <div className="completion">
          <div className="completion__scroll-view">
            <h1 className="completion__title">Lesson Completed</h1>

            <div className="completion__progress">
              <div className="completion__progress-circle">
                <CircularProgressbar
                  value={accuracy * 100}
                  text={``}
                  styles={buildStyles({
                    textColor: "#127FBE",
                    pathColor: "#127FBE",
                    trailColor: "#E1E8ED",
                    textSize: "16px",
                    strokeLinecap: "round",
                  })}
                  counterClockwise={true}
                />
                <p className="completion__accuracy">
                  Accuracy <br /> {(accuracy * 100).toFixed(2)}%
                </p>
              </div>
              <div className="completion__details">
                <p className="completion__details-text">Completion Time</p>
                <p className="completion__details-time">
                  {formatGameTimeStamp(
                    (gameTimeStamp?.end - gameTimeStamp?.start) / 1000
                  )}
                </p>
              </div>
            </div>

            <h2 className="completion__sub-title">Your Learning Progress</h2>

            {points?.map((item, index) => (
              <div className="completion__learnt" key={index}>
                <Icon name="checkBlue" />
                <p className="completion__learnt-text">
                  {truncateString(item, 60)}
                </p>
              </div>
            ))}
          </div>

          <div className="completion__modal">
            <button
              className="completion__modal-btn"
              onClick={() => navigate("/activity")}
            >
              Continue
            </button>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
};
